import React, { createContext, useRef } from 'react';

export const ComplexEditingContext = createContext(null);

const Provider = ({ children }) => {
  const SVG_JSON = useRef(new Map());
  return (
    <ComplexEditingContext.Provider value={SVG_JSON}>
      {children}
    </ComplexEditingContext.Provider>
  );
}

export default Provider;